import { ReactElement } from 'react';
import { OverlayTrigger } from 'react-bootstrap';
import { MdArrowForwardIos, MdLockOutline } from 'react-icons/md';
import { Brand40 } from '../../utils/colors';
import { FullTertiaryNavContainer } from '../../utils/routing/location-constants';
import { Button } from '../Button';
import { Appearance, Background, Placement } from '../designConstants';
import { InternalToolsMenu } from './InternalToolsMenu/InternalToolsMenu';
import { NAV_TERTIARY_POPOVER_CONFIG } from './navbar-constants';
import { useNavTertiaryMenu } from './useNavBarPopover';

interface TertiaryNavContainerProps {
  parentPrettyName: string;
  tertiaryNav: FullTertiaryNavContainer;
}

export const TertiaryNavMenu = ({
  parentPrettyName,
  tertiaryNav
}: TertiaryNavContainerProps): ReactElement => {
  const { key, prettyName, parentIcon, tertiaryNavs } = tertiaryNav;
  const [showMenu, setShowMenu] = useNavTertiaryMenu(prettyName);

  return (
    <OverlayTrigger
      placement={Placement.RIGHT_START}
      trigger='click'
      delay={300}
      show={showMenu}
      onToggle={nextShow => setShowMenu(nextShow)}
      popperConfig={NAV_TERTIARY_POPOVER_CONFIG}
      overlay={
        <InternalToolsMenu
          prettyName={parentPrettyName}
          sections={tertiaryNavs}
          globalIcon={parentIcon}
        />
      }
    >
      <Button
        key={key}
        data-testid='tertiary-nav-trigger'
        appearance={Appearance.EMPTY}
        background={Background.DARK}
        leadingElement={<MdLockOutline color={Brand40} />}
        trailingElement={
          <span className='nav-menu-expander'>
            <MdArrowForwardIos size={14} />
          </span>
        }
        className='subnav-menu-item tertiary-menu-container'
      >
        {prettyName}
      </Button>
    </OverlayTrigger>
  );
};
